<template>

<div id="listing-card-page" class="user-mh-100">
    <div class=" mb-0"></div>
    <section id="listing-product-panel">
        <div class="wrapper">
            <div class="content tab-content pt-0">
                <div class="tab-pane fade show active" role="tabpanel" aria-labelledby="home-tab">
                    <div class="wrapper">
                        <PageLoading :loading="loading" />
                        <template v-if="$page.props.notices.length > 0 && $page.props.notices_show">
                            <Notice :notice="notice" :key="notice.name" v-for="notice in $page.props.notices"></Notice>
                        </template>

                        <ViralProductUpdateTrendNotice
                            v-if="data.productType == 'viral' && $page.props.trending_update_remaining_time_para"
                            :para="$page.props.trending_update_remaining_time_para"
                        />

                        <h6 class="mb-3" v-if="haveRecord">{{ recordInfo }}</h6>
                        <template v-if="haveRecord">

                            <template v-for="(products,date, index) in products.data">
                                <h6 :class="['mb-3 strong h4 fw800 text-uppercase text-danger', (index == 0 ? '' : 'mt-5')]">{{ $filters.dateFormat(date, "dddd: D-MMM-YYYY") }}</h6>
                                <ListViral v-for="v in products" :key="v.id" :v="v"></ListViral>
                            </template>

                            <div class="mt-2">
                                <pagination :links="products.links"></pagination>
                            </div>
                        </template>
                        <template v-else>
                            <div class="mt-5 mb-5">
                                <ProductRecordNotFound :description="recordInfo" />
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>

    </section>
</div>
</template>
<script>

import Pagination from "@s/Components/Inertia/IPagination";
import PageLoading from "./components/PageLoading";
import DateRangeButton from "../../../shared/Components/DateRangeButton";
import ListViral from "./components/ListViral";
import Notice from "./components/Notice";
import ViralProductUpdateTrendNotice from "./components/ViralProductUpdateTrendNotice";
import UserSearchIcon from "@s/Components/Icons/UserSearchIcon";
import ProductRecordNotFound from "./components/ProductRecordNotFound";

export default {
    name: 'GuestProductList',
    components: {
        ProductRecordNotFound,
        Notice,
        DateRangeButton,
        PageLoading,
        'pagination': Pagination,
        ListViral,
        ViralProductUpdateTrendNotice,
        UserSearchIcon
    },
    props: ["products", "data", "filters", "date", "pageTitle", "recordInfo",
        'trending_update_remaining_time',
        'trending_update_remaining_time_para'
    ],
    data() {
      return {
          tf: {
            country: false,
          },
          loading: false,
          f: {... this.filters},
          routes: __st.routes,
          dateTitle: this.date.title,
          dateOptions: {
              ranges: {
                  'Today': [moment(), moment()],
                  'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                  'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                  'Last 10 Days': [moment().subtract(9, 'days'), moment()],
                  'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                  'This Month': [moment().startOf('month'), moment().endOf('month')],
              }
          },
          exp: {
              modalId:  'trending-export-modal',
              form: {
                  export_type: 'csv',
                  export_limit: this.data.rppLimit,
                  aliexpress: 0,
                  amazon: 0,
                  alibaba: 0
              }
          }
      }
    },
    computed: {
        haveRecord() {
            return Object.keys(this.products.data).length > 0;
        }
    },
    mounted() {
        [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
            .map((ttel) => new bootstrap.Tooltip(ttel));

    },
    created() {

        document.title = this.pageTitle;

        if(this.date.startDate) {
            this.dateOptions.startDate = this.date.startDate;
        }

        if(this.date.endDate) {
            this.dateOptions.endDate = this.date.endDate;
        }

        setTimeout(() => {
            [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
                .map((ptel) => new bootstrap.Popover(ptel));
        }, 300)


    },
    methods: {
        submit() {

            this.f.rf = 1;
            var that = this;
            //this.f.title = $("#navbar-searchbar-input").val();
            let queryString = Object.keys(this.f).map(function(key) {
                if(that.f[key] == null) {
                    that.f[key] = '';
                }
                return key + '=' + that.f[key]
            }).join('&');
            const url = this.data.currentUrl+"?"+queryString;
            this.$inertia.visit(url, {
                    only: ['products',"filters", "date", "recordInfo", 'isTrendUpdating', 'notices',
                        'trending_update_remaining_time', 'trending_update_remaining_time_para'],
                    onStart: (visit) => { this.loading = true;  },
                    onFinish: (visit) => {
                        this.loading = false;
                    },
                },
            )
        },

        clearFilters() {
            const filters =  {... this.filters};
            filters.date = '' ;
            this.dateOptions.startDate = '';
            this.dateOptions.endDate = '';
            filters.category = '-1';
            filters.title = '';
            this.f = filters;
            this.f.rf = 0;
        },

        showExport() {
            (new bootstrap.Modal(document.getElementById(this.exp.modalId))).show();
        },
        exportData(){
            var that = this;
            let queryString = Object.keys(this.f).map(function(key) {
                if(that.f[key] == null) {
                    that.f[key] = '';
                }
                return key + '=' + that.f[key]
            }).join('&');
            location.href = this.data.currentUrl+"?"+queryString+"&export=1&export_type="+this.exp.form.export_type+"&export_limit="+this.exp.form.export_limit+"&amazon="+this.exp.form.amazon+"&aliexpress="+this.exp.form.aliexpress+"&alibaba="+this.exp.form.alibaba;
            const modal = bootstrap.Modal.getInstance(document.getElementById(this.exp.modalId))
            modal.hide();

            this.exp.form.aliexpress = 0;
            this.exp.form.alibaba = 0;
            this.exp.form.amazon = 0;

        },
    }
}
</script>

<style>
[v-cloak] { display:none; }
</style>

